import "core-js/modules/es6.string.bold";
import "core-js/modules/es6.string.bold";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
import redBullet from '../../img/red-bullet-point.png';
var RedBulletList = styled.ul.withConfig({
  displayName: "RedBulletList",
  componentId: "sc-16tlwdw-0"
})(["color:", ";> li{list-style-image:url(", ");font-weight:", ";margin-bottom:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.color || null;
}, redBullet, function (_ref2) {
  var bold = _ref2.bold;
  return bold ? '500' : '400';
}, function (_ref3) {
  var marginBottom = _ref3.marginBottom;
  return marginBottom || spacing.base + "px";
});
RedBulletList.propTypes = {
  children: PropTypes.node,
  bold: PropTypes.bool,
  marginBottom: PropTypes.string
};
export default RedBulletList;